module.exports = __webpack_public_path__ + "img/poniter.05863056.png";